import { graphql, useStaticQuery } from 'gatsby';

import { REGION, RegionEnum } from '../constants';

type ContactInfo = {
  phone: string;
  phoneRaw: string;
};

function getTelLink(string: string) {
  return string
    .replace(/ /gi, '')
    .replace(/\+/gi, '00')
    .replace(/\(/gi, '')
    .replace(/\)/gi, '');
}

export const useContactInfo = (): ContactInfo => {
  const { offices } = useStaticQuery<Queries.ContactInfoQuery>(graphql`
    query ContactInfo {
      offices: allContentfulOffice(
        filter: { title: { ne: "DO NOT DELETE Office" } }
        sort: { title: ASC }
      ) {
        nodes {
          title
          phoneNumber
        }
      }
    }
  `);

  if (REGION === RegionEnum.Eu || REGION === RegionEnum.Gb) {
    const { phoneNumber } = offices.nodes.find(
      (office) => office.title === 'Stockholm',
    );

    return {
      phone: phoneNumber,
      phoneRaw: getTelLink(phoneNumber),
    };
  }

  if (REGION === RegionEnum.Us || REGION === RegionEnum.Ca) {
    const { phoneNumber } = offices.nodes.find(
      (office) => office.title === 'Los Angeles',
    );

    return {
      phone: phoneNumber,
      phoneRaw: getTelLink(phoneNumber),
    };
  }
};
